// extracted by mini-css-extract-plugin
export default {"editForm":"styles_editForm__g8-30","editIcon":"styles_editIcon__M7FeM"};